.layout {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 20px;
  align-items: start;
}

.tableCol {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.loading,
.noResults {
  padding: 40px 20px;
  text-align: center;
  font-family: var(--sans);
  font-weight: 600;
  font-size: 13px;
  color: var(--mute);
  background: var(--white);
  border: 1.5px solid var(--line-soft);
  border-radius: var(--r-md);
}

.errorBox {
  padding: 24px;
  background: var(--white);
  border: 2.5px solid var(--red);
  border-radius: var(--r-md);
  font-family: var(--sans);
  font-weight: 700;
  color: var(--red);
}
